import { captalizeFirstLetter } from "@helpers/stringHelpers";
import { parseISO, format, parse } from "date-fns";
import localeBr from "date-fns/locale/pt-BR";

const formatDate = (date: Date) => {
  const day = format(date, "dd", { locale: localeBr });
  const year = format(date, "yyyy", { locale: localeBr });
  const month = format(date, "MMM", { locale: localeBr });

  return `${day} ${captalizeFirstLetter(month)} ${year}`;
};

export const formatISODate = (ISODate: string) => {
  try {
    const date = parseISO(ISODate);
    return formatDate(date);
  } catch (error) {
    throw new Error(`Was not possible to format Date: ${ISODate}. Error: ${error.message}`);
  }
};

export const formatStringDate = (stringDate: string) => {
  try {
    const date = parse(stringDate, "dd/MM/yyyy", new Date());
    return formatDate(date);
  } catch (error) {
    return formatISODate(stringDate);
  }
};
